// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1z9hW","pointer":"style_pointer__19TEk","sectors":"style_sectors__3igTu","sector":"style_sector__3XjIr"};